export const goToUrl = (url: string, target = '_self') => {
  window.open(url, target);
};
